export enum Order {
  DEADLINE = 'deadline',
  NEW_FIRST = 'new_first',
  OLD_FIRST = 'old_first',
}

export enum GoalStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
  COMPLETED = 'COMPLETED',
}
